import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight, Search, Calendar, Clock, User } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const blogPosts = [
  {
    id: 203,
    title: "Módulo de Solicitações da Aroan: Service Requests Enterprise com SLA Inteligente",
    excerpt: "Conheça o módulo de Solicitações do Vértice Aroan: multi-tenant com RLS, SLA com pausa inteligente, chat embutido, auditoria completa e integração nativa com CMDB, KB e CSAT.",
    author: "Equipe Aroan",
    date: "2026-04-28",
    readTime: "10 min",
    category: "Gestão de Serviços",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&auto=format&fit=crop",
    featured: true,
    slug: "/blog/modulo-solicitacoes-aroan"
  },
  {
    id: 202,
    title: "Módulo de Plano de Ação para Formulários: 5W2H, GUT, A3 e 5 Porquês",
    excerpt: "Veja como a Aroan transforma respostas críticas de formulários em planos estruturados com priorização, causa raiz, ações em Kanban e encerramento com lições aprendidas.",
    author: "Equipe Aroan",
    date: "2026-04-10",
    readTime: "8 min",
    category: "Gestão de Serviços",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/modulo-plano-de-acao-formularios"
  },
  {
    id: 201,
    title: "OpenClaw e ITSM: A Revolução da Automação Inteligente e Segura",
    excerpt: "Descubra como o OpenClaw, assistente de IA autônomo e de código aberto, está revolucionando o ITSM com hiperautomação local e soberania de dados.",
    author: "Equipe Aroan",
    date: "2025-02-18",
    readTime: "8 min",
    category: "IA e Automação",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/openclaw-itsm-automacao-inteligente"
  },
  {
    id: 101,
    title: "Mercado de Automação Inteligente: USD 154 Bilhões até 2030",
    excerpt: "O mercado de automação está em explosão, impulsionado pela IA Generativa. Entenda os números e o que isso significa para o futuro dos negócios.",
    author: "Equipe Aroan",
    date: "2024-11-24",
    readTime: "5 min",
    category: "Tendências",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&auto=format&fit=crop",
    featured: true,
    slug: "/blog/mercado-automacao-inteligente"
  },
  {
    id: 102,
    title: "Por que 80% das Empresas Falham em Implementar IA",
    excerpt: "A maioria das iniciativas de IA falha por falta de estratégia e integração. Descubra como evitar as armadilhas comuns e garantir o ROI.",
    author: "Equipe Aroan",
    date: "2024-11-23",
    readTime: "7 min",
    category: "IA e Automação",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/falha-implementacao-ia"
  },
  {
    id: 103,
    title: "60% do Tempo Perdido em Tarefas Repetitivas: Como Resolver a Crise",
    excerpt: "Descubra como a Automação Inteligente transforma o trabalho repetitivo em estratégico e recupera a produtividade da sua equipe.",
    author: "Equipe Aroan",
    date: "2024-11-25",
    readTime: "6 min",
    category: "Produtividade",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/crise-produtividade"
  },
  {
    id: 1,
    title: "Como IA Está Revolucionando a Gestão de Chamados em 2025",
    excerpt: "Descubra como assistentes virtuais inteligentes estão transformando o atendimento ao cliente e reduzindo custos operacionais em até 60%.",
    author: "Maria Silva",
    date: "2024-11-08",
    readTime: "8 min",
    category: "IA e Automação",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&auto=format&fit=crop",
    featured: true,
    slug: "/blog/ia-gestao-chamados-2025"
  },
  {
    id: 2,
    title: "5 Sinais de Que Sua Empresa Precisa de Uma Plataforma Unificada",
    excerpt: "Identifique se sua organização está perdendo eficiência com ferramentas fragmentadas e como resolver isso.",
    author: "João Santos",
    date: "2024-11-05",
    readTime: "6 min",
    category: "Gestão de Serviços",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/sinais-plataforma-unificada"
  },
  {
    id: 3,
    title: "Case: Como a ELEVA IT Reduziu 80% do Tempo de Atendimento",
    excerpt: "Veja como uma empresa de tecnologia implementou AROAN e transformou completamente sua operação de suporte.",
    author: "Ana Costa",
    date: "2024-11-03",
    readTime: "10 min",
    category: "Cases de Sucesso",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&auto=format&fit=crop",
    featured: true,
    slug: "/blog/case-eleeva-it-80-reducao-tempo"
  },
  {
    id: 4,
    title: "Analytics Preditivo: O Futuro da Tomada de Decisão",
    excerpt: "Entenda como previsões baseadas em IA podem antecipar problemas e otimizar recursos antes que afetem seu negócio.",
    author: "Pedro Oliveira",
    date: "2024-11-01",
    readTime: "7 min",
    category: "IA e Automação",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/analytics-preditivo-futuro-decisao"
  },
  {
    id: 5,
    title: "10 Automações Que Todo Service Desk Deveria Ter",
    excerpt: "Lista completa de automações essenciais para eliminar tarefas repetitivas e liberar sua equipe para o que realmente importa.",
    author: "Carlos Mendes",
    date: "2024-10-28",
    readTime: "9 min",
    category: "Produtividade",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/10-automacoes-service-desk"
  },
  {
    id: 6,
    title: "Por Que Assistentes de IA Genéricos Não Funcionam para Empresas",
    excerpt: "Descubra as limitações de ChatGPT e similares em contextos corporativos e por que você precisa de IA especializada.",
    author: "Maria Silva",
    date: "2024-10-25",
    readTime: "8 min",
    category: "IA e Automação",
    image: "https://images.unsplash.com/photo-1677756119517-756a188d2d94?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/ia-genericos-nao-funcionam-empresas"
  },
  {
    id: 7,
    title: "ROI de Plataformas Unificadas: Quanto Você Está Perdendo?",
    excerpt: "Calculadora de custos ocultos mostra quanto a fragmentação de ferramentas está custando para sua empresa.",
    author: "João Santos",
    date: "2024-10-22",
    readTime: "6 min",
    category: "Gestão de Serviços",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/roi-plataformas-unificadas"
  },
  {
    id: 8,
    title: "Tendências em Service Management para 2025",
    excerpt: "As 7 principais tendências que vão moldar o futuro da gestão de serviços empresariais nos próximos anos.",
    author: "Ana Costa",
    date: "2024-12-17",
    readTime: "11 min",
    category: "Tendências",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/tendencias-service-management-2025"
  },
  {
    id: 9,
    title: "Como Implementar IA em Service Desk Sem Resistência da Equipe",
    excerpt: "Estratégias práticas para adoção de IA que transformam sua equipe em defensores da mudança, não resistentes.",
    author: "Equipe Aroan",
    date: "2024-12-17",
    readTime: "15 min",
    category: "Gestão de Serviços",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&auto=format&fit=crop",
    featured: false,
    slug: "/blog/implementar-ia-service-desk"
  },
];

const categoryOrder = ["IA e Automação", "Gestão de Serviços", "Produtividade", "Cases de Sucesso", "Tendências"];

const categories = [
  { name: "Todos", count: blogPosts.length },
  ...categoryOrder.map((category) => ({
    name: category,
    count: blogPosts.filter((post) => post.category === category).length,
  })),
];

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === "Todos" || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredPost = blogPosts.find(post => post.featured);

  return (
    <div className="min-h-screen bg-background">
        <SEO
            title="Blog sobre Gestão de Chamados, Service Desk e IA"
            description="Artigos práticos sobre gestão de chamados, automações de service desk, ITSM e IA aplicada ao atendimento, com cases e dados reais."
            canonical="https://aroan.com.br/blog"
            ogType="website"
            article={false}
        />
        <BreadcrumbSchema
            items={[
                { name: "Home", url: "https://aroan.com.br/" },
                { name: "Blog", url: "https://aroan.com.br/blog" },
            ]}
        />
      <Header />

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-hero overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in">
              Blog <span className="text-primary">AROAN</span>
            </h1>
            <p className="text-lg sm:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto animate-fade-in-delay-1">
              Insights, tendências e melhores práticas sobre IA, automação e gestão de serviços empresariais
            </p>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto animate-fade-in-delay-2">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground w-5 h-5" />
                <Input
                  type="text"
                  placeholder="Buscar artigos..."
                  className="pl-12 pr-4 py-6 text-lg"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      {featuredPost && (
        <section className="py-12 bg-background">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
              <Badge className="bg-primary text-primary-foreground">Artigo em Destaque</Badge>
            </div>
            <div className="grid lg:grid-cols-2 gap-8 items-center bg-card rounded-2xl border border-border overflow-hidden hover:shadow-lg transition-all duration-300 animate-scale-in">
              <div className="relative h-64 lg:h-full min-h-[400px]">
                <img
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <div className="p-8 lg:p-12">
                <Badge variant="outline" className="mb-4">{featuredPost.category}</Badge>
                <h2 className="text-3xl sm:text-4xl font-bold mb-4 hover:text-primary transition-colors">
                  {featuredPost.title}
                </h2>
                <p className="text-muted-foreground mb-6 leading-relaxed text-lg">
                  {featuredPost.excerpt}
                </p>
                <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-6">
                  <div className="flex items-center gap-2">
                    <User className="w-4 h-4" />
                    <span>{featuredPost.author}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    <span>{new Date(featuredPost.date).toLocaleDateString('pt-BR')}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4" />
                    <span>{featuredPost.readTime}</span>
                  </div>
                </div>
                <Button className="group" onClick={() => featuredPost.slug && navigate(featuredPost.slug)}>
                  Ler Artigo Completo
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Categories Filter */}
      <section className="py-8 bg-background border-y border-border">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category, index) => (
              <Button
                key={index}
                variant={selectedCategory === category.name ? "default" : "outline"}
                onClick={() => setSelectedCategory(category.name)}
                className="transition-all duration-300"
              >
                {category.name}
                <Badge variant="secondary" className="ml-2">{category.count}</Badge>
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredPosts.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-xl text-muted-foreground">
                Nenhum artigo encontrado. Tente uma busca diferente.
              </p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post, index) => (
                <article
                  key={post.id}
                  className={`group bg-card rounded-2xl border border-border overflow-hidden hover:shadow-lg transition-all duration-300 animate-scale-in ${post.slug ? 'cursor-pointer' : 'cursor-default'}`}
                  style={{ animationDelay: `${index * 50}ms` }}
                  onClick={() => post.slug && navigate(post.slug)}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <Badge variant="secondary">{post.category}</Badge>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold mb-3 group-hover:text-primary transition-colors line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-muted-foreground mb-4 leading-relaxed line-clamp-3">
                      {post.excerpt}
                    </p>
                    <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground mb-4">
                      <div className="flex items-center gap-1">
                        <User className="w-3 h-3" />
                        <span>{post.author}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Calendar className="w-3 h-3" />
                        <span>{new Date(post.date).toLocaleDateString('pt-BR')}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                    <Button variant="ghost" className="group/btn p-0 h-auto font-semibold">
                      Ler mais
                      <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </article>
              ))}
            </div>
          )}

          {/* Load More */}
          {filteredPosts.length > 0 && (
            <div className="text-center mt-12 animate-fade-in">
              <Button size="lg" variant="outline" className="group">
                Carregar Mais Artigos
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-br from-primary/5 to-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center bg-gradient-to-br from-primary/10 to-primary/5 rounded-3xl p-12 border border-primary/20 animate-fade-in">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">
              Receba Insights <span className="text-primary">Semanais</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Assine nossa newsletter e receba conteúdo exclusivo sobre IA, automação e gestão de serviços
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <Input
                type="email"
                placeholder="Seu melhor email"
                className="flex-1 h-12"
              />
              <Button size="lg" className="group">
                Assinar Grátis
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            <p className="text-sm text-muted-foreground mt-4">
              Sem spam. Cancele quando quiser.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
